import { createStore } from 'redux';
import rootReducer from './reducer';
import rootSagas from './sagas';
import middleware, { runSagas } from './middleware';

export function createGlobalStore(rootReducer, rootSagas, composedEnhancers) {
  let preloadedState = {};
  let is_browser = process.browser == true || process.browser == undefined;

  if (is_browser) {
    preloadedState = window.__PRELOADED_STATE__;
    delete window.__PRELOADED_STATE__;
  }
  const store = createStore(rootReducer, preloadedState, composedEnhancers);
  store.sagaTask = runSagas(rootSagas);
  return store;
}
export default createGlobalStore(rootReducer, rootSagas, middleware);
